const contactFormConfig = {
  region: 'na1',
  portalId: '5553259',
  formId: '4258864f-9973-4abd-bd22-fda4f58a8890',
};

export {
  contactFormConfig,
}